const getters = {
  getMeterConsumptionFields: state => {
    return state.meterConsumptionFields
  },
  
  getThermalMeterConsumptionFields: state => {
    return state.thermalMeterConsumptionFields
  },

  getMeterStatementFields: state => {
    return state.meterStatementFields
  },  

  getThermalMeterStatementFields: state => {
    return state.thermalMeterStatementFields
  },

  getExportMeterStatementFields: state => {
    return state.exportMeterStatementFields
  },

  getExportMeterConsumptionFields: state => {
    return state.exportMeterConsumptionFields
  },

  getExportThermalMeterStatementFields: state => {
    return state.exportThermalMeterStatementFields
  },

  getExportThermalMeterConsumptionFields: state => {
    return state.exportThermalMeterConsumptionFields
  }
}

export default getters